var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPregnancyTest = function SvgPregnancyTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    d: "M6.899 25.699a5.8 5.8 0 0 0 8.202 8.202l6.334-6.334 6.333-6.333a5.8 5.8 0 0 0-8.202-8.202l-6.333 6.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "transparent",
    d: "M18.005 27.426h.001l.598-.599 3.455-3.455.007-.006.006-.007 1.744-1.743a3.275 3.275 0 0 0-4.632-4.632L14.5 21.67l-.533.533-1.782 1.782a3.275 3.275 0 0 0 4.632 4.632zm-.001-2.261 2.365-2.365L18 20.431 15.632 22.8zM14.5 23.93l2.371 2.365-1.188 1.188a1.675 1.675 0 1 1-2.368-2.368zm8.183-3.447L21.5 21.67 19.131 19.3l1.185-1.184a1.675 1.675 0 1 1 2.368 2.368Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "m25.82 11.145 7.844-7.58 4.28 4.43-7.853 7.589"
  })));
};
export default SvgPregnancyTest;